/**
 * Guard for profile routes that require org admin access.
 * Allows access when user is org admin via localStorage, profile role, or has admin in group list.
 */
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAppSelector } from '../redux/hooks';
import ROLES from '../utils/roles';

const ProfileOrgSettingsGuard: React.FC = () => {
  const userDetails = useAppSelector((state) => state.userProfile);
  const groupRoleList = useAppSelector((state) => state.groupRoleList.data) || [];
  const role = localStorage.getItem('role') || '';

  const hasAdminInGroupList = groupRoleList.some((g: { role?: string }) => g?.role === 'admin');
  const isOrgAdmin =
    role === ROLES.platAdmin ||
    role === ROLES.orgAdmin ||
    role === ROLES.grpAdmin ||
    userDetails.data?.role === 2 ||
    hasAdminInGroupList;

  if (isOrgAdmin) {
    return <Outlet />;
  }
  return <Navigate to="/unauthorized" replace />;
};

export default ProfileOrgSettingsGuard;
